import Vue from "vue";
import page404 from "@/views/auth/404.vue";
import page from "@/components/common/page.vue";
import AsyncAutocomplete from "@/components/common/AsyncAutocomplete.vue";
import bpLogo from "@/components/common/bpLogo.vue";
import loading from "@/components/common/loading.vue";
import billFooter from "@/components/common/billFooter.vue";
import datePicker from "@/components/common/dataPicker.vue";
import FormDialog from "@/components/common/FormDialog.vue";
import AdvancedSearch from "@/components/AdvanceSearch.vue";
import FileViewer from "@/components/common/FileViewer.vue";
import FileChooser from "@/components/common/FileChooser.vue";
import searchDialog from "@/components/common/searchDialog.vue";
import customerTile from "@/components/common/customerTile.vue";
import printPreview from "@/components/common/printPreview.vue";
import CustomerImage from "@/components/common/customerImage.vue";
import shortcutDialog from "@/components/common/shortcutDialog.vue";

import debitBill from "@/views/bills/debitBill.vue";
import creditBill from "@/views/bills/creditBill.vue";
import billPreview from "@/views/bills/billPreview.vue";
import exchangeBill from "@/views/bills/exchangeBill.vue";
import exchangeDetail from "@/views/bills/exchangeDetail.vue";
import transferBill from "@/views/bills/transferBill.vue";
import sendTransferDetail from "@/views/bills/sendTransferDetail.vue";
import receiveTransferDetail from "@/views/bills/receiveTransferDetail.vue";
import sendTransferBill from "@/views/bills/sendTransferBill.vue";
import receiveTransferBill from "@/views/bills/receiveTransferBill.vue";

import persons from "@/views/people/persons.vue";
import DebitForm from "@/views/forms/DebitForm.vue";
import CreditForm from "@/views/forms/CreditForm.vue";
import exchangeForm from "@/views/forms/exchangeForm.vue";
// import transferForm from "@/views/forms/transferForm.vue";
import a2aTransferForm from "@/views/forms/a2aTransferForm.vue";
import sendTransferForm from "@/views/forms/sendTransferForm.vue";
import receiveTransferForm from "@/views/forms/receiveTransferForm.vue";

// common components
Vue.component("page", page);
Vue.component("persons", persons);
Vue.component("page-404", page404);
Vue.component("v-loading", loading);
Vue.component("file-viewer", FileViewer);
Vue.component("bill-footer", billFooter);
Vue.component("form-dialog", FormDialog);
Vue.component("a-search", AdvancedSearch);
Vue.component("bill-preview", billPreview);
Vue.component("file-chooser", FileChooser);
Vue.component("print-preview", printPreview);
Vue.component("search-dialog", searchDialog);
Vue.component("shortcut-dialog", shortcutDialog);
Vue.component("async-autocomplete", AsyncAutocomplete);

Vue.component("debit-bill", debitBill);
Vue.component("credit-bill", creditBill);
Vue.component("exchange-bill", exchangeBill);
Vue.component("transfer-bill", transferBill);
Vue.component("exchange-detail", exchangeDetail);
Vue.component("send-transfer-bill", sendTransferBill);
Vue.component("send-transfer-detail", sendTransferDetail);
Vue.component("receive-transfer-bill", receiveTransferBill);
Vue.component("receive-transfer-detail", receiveTransferDetail);

Vue.component("debit", DebitForm);
Vue.component("credit", CreditForm);
Vue.component("exchange-form", exchangeForm);
// Vue.component("transfer-form", transferForm);
Vue.component("a2a-transfer-form", a2aTransferForm);
Vue.component("send-transfer-form", sendTransferForm);
Vue.component("receive-transfer-form", receiveTransferForm);

Vue.component("bp-logo", bpLogo);
Vue.component("v-date", datePicker);
Vue.component("customer-tile", customerTile);
Vue.component("customer-image", CustomerImage);
